import react, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import Login from '../../../../containers/forms/login/Login';

import { TelaModalLivre } from '../../../../helpers/TelaModal';

const Autenticacao = (props) => {

    const [show, handleModal] = useState(true);
    const [loginoptionsaccess, setLoginOptionsAccess] = useState(false);

    const handleLoginOptionsAccess = () => {
        setLoginOptionsAccess(loginoptionsaccess===true?false:true);
    }

    return (
        <TelaModalLivre titulo="Gerenciamento"
        handleCloseModal={() => {
            handleModal();
            props.history.push('/dashboard');
        }} 
        show={show} >
            <Login idcategoria={3} idevento={0} idpromotora={0} loginoptionsaccess={loginoptionsaccess} handleLoginOptionsAccess={handleLoginOptionsAccess} />
        </TelaModalLivre>
    )
}

export default withRouter(Autenticacao);